export const curriculumCollectionId = ["neCurriculums", "eeCurriculums"] as const;
export type CurriculumCollectionId = typeof curriculumCollectionId[number];

export function isCurriculumCollectionId(value: unknown): value is CurriculumCollectionId {
  return curriculumCollectionId.some(v => v === value);
}
